/*
 *
 * RestaurantsList reducer
 *
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  FETCH_RESTURANTLIST_SUCCESS,
  FETCH_RESTURANTPAGE_SUCCESS,
  // FETCH_RESTURANTLIST,
} from './constants';

const initialState = fromJS({
  isLoading: false,
  restaurantList: {},
  restaurantLocations: [],
  restaurantCuisines: [],
  restaurantCollection: [],
  restaurantDeal: [],
});

function restaurantsListReducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case DEFAULT_ACTION:
      return state
        .set('isLoading', payload);
    case FETCH_RESTURANTPAGE_SUCCESS: {
      const { merchant_data, locations, cuisines, collection, deal } = payload;
      return state
        .set('restaurantList', fromJS(merchant_data))
        .set('restaurantLocations', fromJS(locations))
        .set('restaurantCuisines', fromJS(cuisines))
        .set('restaurantCollection', fromJS(collection))
        .set('restaurantDeal', fromJS(deal))
        .set('isLoading', false);
    }
    case FETCH_RESTURANTLIST_SUCCESS:
      return state
        .set('restaurantList', fromJS(payload.merchant_data))
        .set('isLoading', false);
    default:
      return state;
  }
}

export default restaurantsListReducer;



// WEBPACK FOOTER //
// client/containers/RestaurantsList/reducer.js